var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgStar = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 22,
  height: 22,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m11.006.447-.691 1.64-2.378 5.645L.5 8.54l5.563 5.248-1.58 7.741 6.523-3.97 6.518 3.97-1.576-7.742 5.558-5.247-7.431-.808-3.07-7.285Zm0 3.86 2.032 4.819 5.083.55-3.806 3.596 1.054 5.189-4.363-2.659-4.369 2.659 1.06-5.189-3.8-3.596 5.077-.55 2.032-4.82Z",
  fill: "#6B6B6B"
})));
export default SvgStar;